import { Vimeo } from 'react-native-vimeo-iframe'
import { useState } from 'react'
import { getToken } from 'tamagui'
import { IUpdateLessonProgress } from '@components/MediaRender'

interface IVimeoVideoPlayerProps {
  videoId: string
  updateProgress: (params: IUpdateLessonProgress) => void
  videoStartTime?: number
  actualProgress?: number
}

interface IVimeoVideoPlayerData {
  currentTime: number
  duration: number
  percent: number
}

interface IVimeoVideoPlayerCallbacks {
  timeupdate: (data: IVimeoVideoPlayerData) => void
}

const thresholds = [25, 50, 75, 100] as const

export function VimeoVideoPlayer({
  videoId,
  updateProgress,
  videoStartTime,
  actualProgress = 0,
}: IVimeoVideoPlayerProps) {
  const [progressMarkers, setProgressMarkers] = useState({
    25: actualProgress >= 25,
    50: actualProgress >= 50,
    75: actualProgress >= 75,
    100: actualProgress >= 100,
  })
  const videoBorderRadius = getToken('$border-radius-md')

  const videoCallbacks: IVimeoVideoPlayerCallbacks = {
    timeupdate: (data) => {
      thresholds.forEach((threshold) => {
        if (data.percent >= threshold && !progressMarkers[threshold]) {
          setProgressMarkers((prev) => ({ ...prev, [threshold]: true }))
          updateProgress?.({
            progress: threshold,
            currentVideoTime: Math.floor(data.currentTime),
          })
        }
      })
    },
  }

  return (
    <Vimeo
      videoId={videoId}
      params={`api=1&autoplay=0&start=${videoStartTime}`}
      handlers={videoCallbacks}
      style={{
        borderRadius: videoBorderRadius,
        backgroundColor: 'transparent',
      }}
    />
  )
}
